import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Table } from "semantic-ui-react";

const GridEmptyRow = ({ hasFilter, colSpan }) => {
  const intl = useIntl();
  return (
    <Table.Row>
      <Table.Cell
        colSpan={colSpan}
        textAlign="center"
      >
        {hasFilter
          ? intl.formatMessage({
              id: "EMPTY_SEARCH_RESULTS",
              defaultMessage: "No results found",
            })
          : intl.formatMessage({
              id: "LABEL_NO_DATA_AVAILABLE",
              defaultMessage: "No data available",
            })}
      </Table.Cell>
    </Table.Row>
  );
};

export default GridEmptyRow;

GridEmptyRow.propTypes = {
  hasFilter: PropTypes.bool.isRequired,
  colSpan: PropTypes.number.isRequired,
};
